import React from 'react';
import * as FiIcons from 'react-icons/fi';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("Uncaught error:", error, errorInfo);
    this.setState({ errorInfo });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50 p-6">
          <div className="max-w-xl w-full bg-white rounded-xl shadow-xl overflow-hidden">
            <div className="bg-red-600 p-6 text-white">
              <h2 className="text-2xl font-bold flex items-center gap-2">
                <FiIcons.FiAlertTriangle /> Ein Fehler ist aufgetreten
              </h2>
              <p className="mt-2 opacity-90">Die Anwendung konnte nicht geladen werden.</p>
            </div>
            <div className="p-6">
              <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-6 text-sm text-red-800 font-mono whitespace-pre-wrap overflow-auto max-h-48">
                {this.state.error && this.state.error.toString()}
              </div>
              
              <div className="text-sm text-gray-600 mb-6">
                <p>Versuchen Sie Folgendes:</p>
                <ul className="list-disc list-inside mt-2 space-y-1">
                  <li>Seite neu laden</li>
                  <li>Browser-Cache leeren</li>
                  <li>Local Storage löschen (Button unten)</li>
                </ul>
              </div>

              <div className="flex gap-4">
                <button
                  onClick={() => window.location.reload()}
                  className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 font-medium"
                >
                  Neu laden
                </button>
                <button
                  onClick={() => {
                    localStorage.clear();
                    window.location.reload();
                  }}
                  className="px-4 py-2 bg-gray-200 text-gray-800 rounded-lg hover:bg-gray-300 font-medium"
                >
                  App zurücksetzen (Daten löschen)
                </button>
              </div>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}